import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Check, Building2, Calendar, FileText, MessageSquare } from 'lucide-react';

const CTASection = () => {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: Building2,
      title: 'Mayor visibilidad online',
      description: 'Aparece en las búsquedas de miles de pacientes potenciales'
    },
    {
      icon: Calendar,
      title: 'Gestión de citas online',
      description: 'Sistema de agendamiento automático las 24 horas'
    },
    {
      icon: FileText,
      title: 'Historiales clínicos digitales',
      description: 'Toda la información de tus pacientes organizada y segura'
    },
    {
      icon: MessageSquare,
      title: 'Comunicación con pacientes',
      description: 'Recordatorios automáticos y mensajes personalizados'
    }
  ];

  return (
    <div className="py-20 bg-gradient-to-br from-cyan-600 to-blue-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h2 className="text-4xl font-bold mb-6">
              ¿Tienes una clínica dental?
            </h2>
            <p className="text-xl text-cyan-100 mb-8">
              Únete a nuestro directorio y potencia tu presencia online. Además te ofrecemos nuestro software de gestión que te ayudará a optimizar tus procesos y mejorar la experiencia de tus pacientes.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              {benefits.map((benefit, index) => {
                const Icon = benefit.icon;
                return (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-cyan-500">
                        <Icon className="h-6 w-6 text-white" />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-semibold text-white mb-1">{benefit.title}</h3>
                      <p className="text-sm text-cyan-100">{benefit.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="flex flex-wrap gap-4">
              <Button 
                size="lg"
                className="bg-white text-cyan-600 hover:bg-cyan-50 font-semibold"
                onClick={() => navigate('/registrar-clinica')}
              >
                Registrar mi clínica
              </Button>
              {/* <Button 
                size="lg"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-cyan-600 font-semibold"
              >
                Conocer más del software
              </Button> */}
            </div>
          </div>

          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img src="/tuclinicapp-dentista.png"  
                alt="Software para clínicas dentales"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
